<template>
  <div :class="{
      'interactive-social-wall__modal-post-layout--with-media':
        postMediaFiles.length,
    }"
       class="interactive-social-wall__modal-post-layout">
    <SocialWallPostMedia v-if="postMediaFiles.length" :media-files="postMediaFiles"/>

    <section class="interactive-social-wall__modal-context">
      <div class="interactive-social-wall__modal-post-context-title">
        <span>
          <i aria-hidden="true" class="uil-comment-alt-lines"/>
          {{$t('general.post_text')}}
        </span>
      </div>
      <article class="interactive-social-wall__modal-post">
        <SocialWallAvatar :name="authorName" :photo="authorPhoto"
                          class="interactive-social-wall__modal-post-avatar"/>

        <div class="interactive-social-wall__modal-post-content">
          <div class="interactive-social-wall__modal-post-meta">
            <strong>{{ authorName }}</strong>
            <time :datetime="post.created_at || ''">{{ postTimeText }}</time>
          </div>
          <p>{{ post.text }}</p>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import UserProfileAvatar from "../../../../components/common/UserProfileAvatar.vue";
import SocialWallPostMedia from "./SocialWallPostMedia.vue";
import {
  relativeTime as formatRelativeTime,
  userName as formatUserName,
  userPhoto as resolveUserPhoto,
} from "../utils/presentation";

export default {
  name: "SocialWallPostPreview",
  components: {
    SocialWallAvatar: UserProfileAvatar,
    SocialWallPostMedia,
  },
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    authorName() {
      return formatUserName(this.post?.user);
    },
    authorPhoto() {
      return resolveUserPhoto(this.post?.user);
    },
    postTimeText() {
      return formatRelativeTime(this.post);
    },
    postMediaFiles() {
      const files = Array.isArray(this.post?.files) ? this.post.files : [];
      return files.filter((file) => {
        const fileType = Number(file?.file_type);
        return Boolean(file?.file_link) && (fileType === 1 || fileType === 2);
      });
    },
  },
};
</script>

<style scoped>
.interactive-social-wall__modal-post-layout,
.interactive-social-wall__modal-post-layout * {
  box-sizing: border-box;
}

.interactive-social-wall__modal-post-layout {
  background: #f8fafb;
  border-bottom: 1px solid #e8ebf0;
}

.interactive-social-wall__modal-post-layout--with-media {
  display: grid;
  height: min(420px, 55vh);
  height: min(420px, 55dvh);
  max-height: calc(100vh - 180px);
  max-height: calc(100dvh - 180px);
  align-items: stretch;
  grid-template-columns: minmax(0, 0.9fr) minmax(300px, 1.1fr);
  overflow: hidden;
  border: 1px solid #e0e5eb;
  border-radius: 10px;
}

.interactive-social-wall__modal-post-layout--with-media
  > .interactive-social-wall__modal-context {
  display: flex;
  height: 100%;
  flex-direction: column;
  min-height: 0;
}

.interactive-social-wall__modal-post-layout--with-media
  .interactive-social-wall__modal-post {
  flex: 1 1 auto;
  min-height: 0;
}

.interactive-social-wall__modal-post-layout--with-media
  .interactive-social-wall__modal-post-content {
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
}

.interactive-social-wall__modal-post-layout--with-media
  .interactive-social-wall__modal-post-content > p {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
}

.interactive-social-wall__modal-context {
  min-width: 0;
  padding: 16px 18px;
  background: #f8fafb;
}

.interactive-social-wall__modal-post-context-title {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 9px;
  color: #5f6b7c;
}

.interactive-social-wall__modal-post-context-title > span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 8.5px;
  font-weight: 700;
  line-height: 1.3;
  text-transform: uppercase;
}

.interactive-social-wall__modal-post-context-title > span i {
  font-size: 13px;
}

.interactive-social-wall__modal-post {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e2e7ed;
  border-radius: 8px;
}

.interactive-social-wall__modal-post-avatar {
  display: inline-flex;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  border-radius: 50%;
}

.interactive-social-wall__modal-post-content {
  flex: 1;
  min-width: 0;
}

.interactive-social-wall__modal-post-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.interactive-social-wall__modal-post-meta strong {
  overflow: hidden;
  color: #111827;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.interactive-social-wall__modal-post-meta time {
  flex: 0 0 auto;
  color: #7a8495;
  font-size: 9px;
  line-height: 1.4;
}

.interactive-social-wall__modal-post-content > p {
  max-height: 30vh;
  max-height: min(220px, 30dvh);
  margin: 5px 0 0;
  padding-right: 4px;
  overflow-y: auto;
  overscroll-behavior: contain;
  color: #303846;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.55;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

@media (max-width: 760px) {
  .interactive-social-wall__modal-post-layout--with-media {
    height: auto;
    min-height: 0;
    max-height: none;
    display: flex;
    border: 0;
    border-radius: 0;
    flex-direction: column;
  }

  .interactive-social-wall__modal-post-layout--with-media
    > .interactive-social-wall__modal-context {
    height: auto;
  }

  .interactive-social-wall__modal-post-layout--with-media
    .interactive-social-wall__modal-post-content {
    height: auto;
  }

  .interactive-social-wall__modal-post-layout--with-media
    .interactive-social-wall__modal-post-content > p {
    flex: 0 1 auto;
    max-height: 160px;
    max-height: min(160px, 22vh);
    max-height: min(160px, 22dvh);
    overscroll-behavior-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 480px) {
  .interactive-social-wall__modal-context {
    padding-right: 14px;
    padding-left: 14px;
  }
}
</style>
